// extracted by mini-css-extract-plugin
module.exports = {"result":"Result_result__1ZbGz","result__text":"Result_result__text__188vf"};